import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import amplifyConfig from './configs/amplify';
import AuthenticationProvider from './contexts/Authentication';
import { getCompanyThemeData } from './Theme';
import AnalyticsProvider from './contexts/Analytics';
import { defaultPrimaryColor, $color15 } from './styles/Variables';

Bugsnag.start({
  apiKey: '85591af5b620f7e17744accbd7e9d890',
  plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react')!
  .createErrorBoundary(React);

const companyTheme = getCompanyThemeData();

document.title = `${companyTheme.pageTitle ?? 'Authentication'} | Buyer`;

const ct = createMuiTheme({
  palette: {
    primary: {
      main: companyTheme.primaryColor ?? defaultPrimaryColor,
    },
  },
  overrides: {
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: `2px solid ${$color15}`,
        },
        '&:hover:not($disabled):before': {
          borderBottom: `2px solid ${$color15}`,
        },
      },
    },
  },
});

Amplify.configure(amplifyConfig);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <MuiThemeProvider theme={ct}>
        <AnalyticsProvider>
          <AuthenticationProvider>
            <App />
          </AuthenticationProvider>
        </AnalyticsProvider>
      </MuiThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
